import { useHistory } from "react-router-dom";
import SubHeaderNegociation from "../SubHeaderNegociation";
import { useCommercialSales } from "../../../providers/CommercialSalesContext";
import {
  Container,
  ContainerCard,
  Header,
  BackButton,
  ContainerSubHeader,
  VisitContainer,
  InternalVisitContainer,
  AddContainer,
  HeaderAnotherProduct,
  ButtonRequest,
  VisitContainerScroll,
  AddButton,
} from "./style";
import { useEffect, useState } from "react";

const ModalVisitCustomer = ({setShowModal, isIndustry}) => {
  const history = useHistory()
  const {currentNegociation, aceptNegociation, setCurrentNegociation, finishNegociation,statusContext , currentScheduling, getCurrentNegociation, currentVisita} = useCommercialSales()
  const [filterSelectedSubHeader, setFilterSelectedSubHeader] = useState([true, true, true, true])


  useEffect(() => {

  console.log(currentNegociation)
    

    // if (isIndustry) {

    //   if(currentScheduling.aceita === "A") {
    //     setStatus("Aguardando Supermercado")
    //   } else if (currentScheduling.aceita === "I") {
    //     setStatus("Aguardando")
    //   }
    //   else if (currentScheduling.aceita === "P") {
    //     setStatus("Aceito")
    //   }
    //   else if (currentScheduling.aceita === "R") {
    //     setStatus("Rejeitado")
    //   } else {
    //     setStatus("Faça um Proposta")
    //   }

    // } else {

    //   if(currentScheduling.aceita === "A") {
    //     setStatus("Aguardando Supermercado")
    //   } else if (currentScheduling.aceita === "I") {
    //     setStatus("Aguardando")
    //   }
    //   else if (currentScheduling.aceita === "P") {
    //     setStatus("Aceito")
    //   }
    //   else if (currentScheduling.aceita === "R") {
    //     setStatus("Rejeitado")
    //   } else {
    //     setStatus("Faça um Proposta")
    //   }

    // }

    var arraySelected = [false, false, false, false]

    currentNegociation?.forEach(element => {
      if (element.produto.produto === 7) {

        arraySelected[0] = true

      } else if (element.produto.produto === 8) {

        arraySelected[1] = true

      } else if (element.produto.produto === 9) {

        arraySelected[2] = true

      } else if (element.produto.produto === 10) {

        arraySelected[3] = true

      }
    });

    setFilterSelectedSubHeader(arraySelected)

    if (currentNegociation.length < 1) {
      setShowModal(false)
    }

  }, [currentNegociation])

  function removeItemNegociation(itemToRemove) {
    setCurrentNegociation(currentNegociation?.filter(item => item !== itemToRemove));
  }

  function handleAceptNegociation() {

    aceptNegociation()
    setShowModal(false)
    getCurrentNegociation(currentVisita.visita)

  }

  function handleFinishNegociation() {

    if (isIndustry) {

      finishNegociation("A", isIndustry)
      setShowModal(false)
      getCurrentNegociation(currentVisita.visita)

    } else {

      finishNegociation("I", isIndustry)
      setShowModal(false)
      getCurrentNegociation(currentVisita.visita)

    }

  }

  return (
    <Container>
      <ContainerCard>
        <Header>
          <h1>Propostas</h1>
          <BackButton
            src="/images/back_button.svg"
            onClick={() => setShowModal(false)}
          />
        </Header>

        <VisitContainerScroll>

        {currentNegociation?.map((item) => {

        return (
          <VisitContainer>
            <InternalVisitContainer>
              <img src="./images/market_basket.svg" alt="market_basket" />
              <p>{item.produto.nome}</p>
              <AddContainer onClick={() => removeItemNegociation(item)}>
                {/* <Signal /> */}
                <AddButton>x</AddButton>
              </AddContainer>
            </InternalVisitContainer>
          </VisitContainer>
        )

        })}

        </VisitContainerScroll>
        
        {
          currentNegociation.length < 4 &&

          <>
          <HeaderAnotherProduct>
          Deseja negociar outro produto?
          </HeaderAnotherProduct>
          <ContainerSubHeader>
            <SubHeaderNegociation
              style={filterSelectedSubHeader}
              path1={isIndustry ? "toolsCommercialSausage" : "mpPurchasesSausage"}
              path2={isIndustry ? "toolsCommercialChicken" : "mpPurchasesChicken" }
              path3={isIndustry ? "toolsCommercialChickenCut" : "mpPurchasesChickenCut"}
              path4={isIndustry ? "toolsCommercialFries" : "mpPurchasesFries" }
            />
          </ContainerSubHeader>
          </>
          
        }
       
        {
          statusContext !== "P" && statusContext !== "E" && statusContext !== "R" ?

          <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            onClick={() => handleFinishNegociation()}
            style={{background: "#ffd700"}}>
              Enviar Proposta
          </ButtonRequest> :
          <></>

        }

        {
          statusContext === "P" &&
          <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            // onClick={() => handleAceptNegociation()}
            // style={{background: "#ffd700"}}
            >
              Proposta Aceita
          </ButtonRequest>
        }
        

        {
          statusContext === "I" && isIndustry ?
          <>
          <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            onClick={() => handleAceptNegociation()}
            // style={{background: "#ffd700"}}
            >
              Aceitar Proposta
          </ButtonRequest>
          {/* <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            onClick={() => handleAceptNegociation()}
            style={{background: "red"}}
            >
              Rejeitar Proposta
          </ButtonRequest> */}
          </> :
          <></>
        }

        {
          statusContext === "A" && !isIndustry ?
          <>
          <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            onClick={() => handleAceptNegociation()}
            // style={{background: "#ffd700"}}
            >
              Aceitar Proposta
          </ButtonRequest>
          {/* <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            onClick={() => handleAceptNegociation()}
            style={{background: "red"}}
            >
              Rejeitar Proposta
          </ButtonRequest> */}
          </> :
          <></>
        }
        
        {/* {
          isIndustry 
          ?
          status === "Rejeitado" ? 
          (
            <h2>Sua oferta foi rejeitada...</h2>
          )
          :
          status === "Faça uma proposta" ?
          (
            <ButtonRequest
            //  onClick={() => sendOffer("A")} 
            onClick={() => isIndustry ? finishNegociation("A") : finishNegociation("I")}
             style={{background: "#ffd700"}}>
               Finalizar Proposta
            </ButtonRequest>
          )
          :
          status === "Aceito" ?
          (
            <h2>Sua oferta foi aceita!</h2>
          )
          :
          status === "Aguardando Supermercado" ?
          (
            <></>
          ) 
          :
          (
            <>
              <ButtonRequest 
              // onClick={() => sendOffer("P")} 
              >
                Aceitar
              </ButtonRequest>
              <ButtonRequest
                //  onClick={() => sendOffer("A")} 
                onClick={() => isIndustry ? finishNegociation("A") : finishNegociation("I")}
                style={{background: "#ffd700"}}>
                  Finalizar Proposta
              </ButtonRequest>
              <ButtonRequest 
              // onClick={() => sendOffer("R")} style={{background: "red"}}
              >Rejeitar</ButtonRequest>
            </>
          )
        :
        status === "Rejeitado" ? 
                (
                  <h2>Sua oferta foi rejeitada...</h2>
                )
                :
                status === "Faça uma proposta" ?
                (
                  <ButtonRequest
                  //  onClick={() => sendOffer("A")} 
                  onClick={() => isIndustry ? finishNegociation("A") : finishNegociation("I")}
                   style={{background: "#ffd700"}}>
                     Finalizar Proposta
                  </ButtonRequest>
                )
                :
                status === "Aceito" ?
                (
                  <h2>Sua oferta foi aceita!</h2>
                )
                :
                status === "Aguardando Indústria" ?
                (
                  <></>
                ) 
                :
                (
                  <>
                    <ButtonRequest 
                    // onClick={() => sendOffer("P")} 
                    >
                      Aceitar
                    </ButtonRequest>
                    <ButtonRequest
                      //  onClick={() => sendOffer("A")} 
                      onClick={() => isIndustry ? finishNegociation("A") : finishNegociation("I")}
                      style={{background: "#ffd700"}}>
                        Finalizar Proposta
                    </ButtonRequest>
                    <ButtonRequest 
                    // onClick={() => sendOffer("R")} style={{background: "red"}}
                    >Rejeitar</ButtonRequest>
                  </>
                )
                
                
              } */}
        
        
        {/* <VisitContainer>
          <InternalVisitContainer>
            <img src="./images/market_basket.svg" alt="market_basket" />
            <p>Guanabara</p>
            <AddContainer>
              <Signal />
              <AddButton>+</AddButton>
            </AddContainer>
          </InternalVisitContainer>
        </VisitContainer> */}
      </ContainerCard>
    </Container>
  );
};
export default ModalVisitCustomer;
